export const uploadLargeFileForProcess = async (
  url, 
  path, 
  token, 
  file, 
  chunkSize, 
  customerId,
  priceId,
  dataForProcess,
) => {
    if (!file) {
      throw new Error('file is required')
    }
    // return alert("Select a video file first!");

    const CHUNK_SIZE = chunkSize;

    // setUploading(true);
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    
    // Create a sanitized unique ID for this upload session
    const fileId = `${Date.now()}-${file.name.replace(/[^a-zA-Z0-9]/g, "")}`;

    console.log('customerId', customerId, priceId)
    // const fSplit = file.name.split('.');
    // const ext = fSplit.pop();
    // const fileId = `${userId}-${Date.now()}-largefile.${ext}}`;
    // console.log('fileId', fileId);
    
    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      
      // Get raw slice data
      const chunk = file.slice(start, end);

      try {
        const response = await fetch(url + path, {
          method: 'POST',
          // Send headers instead of FormData fields
          headers: {
            'x-file-id': fileId,
            'x-file-name': encodeURIComponent(file.name), // Safely escape special characters
            'x-chunk-index': chunkIndex.toString(),
            'x-total-chunks': totalChunks.toString(),
            'Content-Type': 'application/octet-stream', // Informs server this is raw binary
            
            Authorization: 'Bearer ' + token,
            'customer-id': customerId,
            'price-id': priceId,
            'data-for-process': encodeURIComponent( JSON.stringify(dataForProcess) ),  // data object for process after upload
          },
          body: chunk, // Send raw chunk data directly
        });

        if (!response.ok) throw new Error("Network response error.");
        
        // const resData = await response.json();
        // console.log(response, resData);

        const percentComplete = Math.round(((chunkIndex + 1) / totalChunks) * 100);
        
        // console.log('chunkIndex, totalChunks', chunkIndex ,totalChunks)
        // setProgress(percentComplete);
        
        if (chunkIndex === totalChunks - 1) {
          return response;
        }
        // return percentComplete;
      } catch (error) {
        console.error("Upload error:", error);
        throw error;
        // alert(`Failed at chunk ${chunkIndex + 1}`);
        // setUploading(false);
        // return;
      }
    }

    // alert("Video successfully uploaded!");
    // setUploading(false);
  };


export const s3fileUploadLf = async (
    url, 
    token, 
    storePath, 
    file, 
    bucketName,
    totalFileNum,
    fileIdx,
    uploadApp,
    customerId,
    priceId,
  ) => {
    try {
      // let priceId;

      // if (usageBasedPrice) {
      //   priceId = usageBasedPrice.id;
      // }
    
      const dataForProcess = {
        bucket: bucketName,
        storePath: storePath,
        filename: file.name,
        totalFileNum: totalFileNum,
        fileIdx: fileIdx,
        // uploadId: localStorage.getItem('userId') + '-' + Date.now(),
        uploadApp: uploadApp,
        processAction: 'storeFiles',
        
        // fileSize: file.size,
      };

      const response = await uploadLargeFileForProcess(
        url,
        `/bucket/object2`,
        token,
        file,
        5*10**6,
        customerId,
        priceId,
        dataForProcess,
      );

      if (!response.ok) {
        throw new Error('error occured')
      }

      const resData = await response.json()
      // console.log(response, resData);
      if (resData.data && resData.dataForMetadata) {
        return resData;
      }

    } catch(err) {
      console.log(err);
      // throw err;
    }
  
  };